export default __webpack_public_path__ + "static/media/9.87b55c41.png";